import React from "react";
import { Button } from "./ui/button";
import { useToast } from "../hooks/use-toast";
import { Share2 } from "lucide-react";

export default function ShareBox({ variant = "subpage", containerClass = "", widthClass = "w-full md:w-1/2" }) {
  const { toast } = useToast();
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const title = "Nofap Journey — Free 27‑week course";
  const text = "A hopeful, structured, 27‑week guide. Progress is saved on your device.";

  const onShare = async () => {
    try {
      if (navigator.share) {
        await navigator.share({ title, text, url: origin });
      } else {
        await navigator.clipboard.writeText(origin);
        toast({ title: "Link copied", description: origin });
      }
    } catch (_) {
      // user canceled or unsupported
    }
  };

  let boxCls = "rounded-xl p-4";
  if (variant === "home") boxCls = "brand-gradient with-shapes elevated-card rounded-xl p-4 sm:p-5";
  else if (variant === "themed") boxCls = "elevated-card rounded-xl p-4 ring-1 ring-inset ring-slate-200 dark:ring-slate-700";
  else boxCls = "rounded-xl border border-slate-200 dark:border-slate-800 p-4";

  return (
    <section className={`mt-4 sm:mt-6 ${containerClass}`}>
      <div className="flex flex-col md:flex-row items-stretch md:items-start justify-between gap-6 md:gap-4">
        {/* Share box (left) */}
        <div className={widthClass}>
          <div data-tour-id="share-box" className={boxCls}>
            <div className="flex items-center justify-between gap-3">
              <div>
                <div className="text-sm font-semibold text-slate-900 dark:text-slate-100">Share Somemas Recovery</div>
              </div>
              <Button onClick={onShare} className="btn-primary" size="sm">
                <Share2 className="h-4 w-4 mr-2" /> Share
              </Button>
            </div>
          </div>
        </div>
        {/* Buy me a coffee (right) */}
        <div className="w-full md:w-1/2" data-tour-id="support-card">
          <div className={`${variant === 'home' ? 'brand-gradient with-shapes elevated-card' : variant === 'themed' ? 'elevated-card' : 'rounded-xl border border-slate-200 dark:border-slate-800'} rounded-xl p-4 sm:p-5`}>
            <div className="text-sm font-semibold text-slate-900 dark:text-slate-100">😄 Enjoying this site?</div>
            <div className="text-xs sm:text-sm text-slate-600 dark:text-slate-300 leading-relaxed">If everybody chipped in just $2/month, it would make a huge difference.</div>
            <a
              data-tour-id="support-button"
              href="https://www.buymeacoffee.com/recoverylifestyle"
              target="_blank"
              rel="noopener noreferrer"
              className="block mt-2 w-full"
              aria-label="Support the Website Creator"
            >
              <img
                src="https://img.buymeacoffee.com/button-api/?text=Click to Support The Website&emoji=😃&slug=recoverylifestyle&button_colour=174954&font_colour=ffffff&font_family=Cookie&outline_colour=ffffff&coffee_colour=FFDD00"
                alt="Buy me a coffee"
                className="w-full h-auto"
              />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}